module.exports = __webpack_public_path__ + "img/lcbannerzhTc.d7b3fd2d.png";